import Vue from "vue";

const getDefaultState = () => {
  return {
    quickAddOpen: false,
    task: "",
    tasks: [],

    isOpen: false,
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },

  toggleQuickAdd() {
    state.quickAddOpen = !state.quickAddOpen;
  },

  toggleIsOpen() {
    state.isOpen = !state.isOpen;
  },
  closeTasks() {
    state.isOpen = false;
  },

  completeOneItemByID(itemID) {
    const itemIndex = state.tasks.findIndex((item) => item._id === itemID);
    if (itemIndex !== -1) Vue.set(state.tasks[itemIndex], "complete", true);
  },

  uncompleteOneItemByID(itemID) {
    const itemIndex = state.tasks.findIndex((item) => item._id === itemID);
    if (itemIndex !== -1) Vue.set(state.tasks[itemIndex], "complete", false);
  },

  setTask(task) {
    state.task = task;
  },

  setAllTasks(tasks) {
    state.tasks = [...state.tasks, ...tasks];
  },

  clearTasks() {
    state.tasks = [];
  },

  addTask(task) {
    state.tasks.unshift(task);
  },

  removeTask(taskId) {
    for (var i = state.tasks.length - 1; i > -1; i--) {
      let task = state.tasks[i];
      if (task._id.toString() == taskId.toString()) {
        state.tasks.splice(i, 1);
      }
    }
  },
};

export default {
  state,
  methods,
};
